<div matTooltip="Importing elements is disabled while your documents are being processed" matTooltipDisabled="{{!isProcessing}}">
  <button
    title="New"
    *ngIf="canImport || canCreateFolders || canCreateTemplate"
    [disabled]="isProcessing"
    #newButton="matMenuTrigger"
    [matMenuTriggerFor]="newMenu"
    [matMenuTriggerRestoreFocus]="false"
    class="button margin-bottom-2 new__button"
    data-cy="new-button"
    [class.hollow]="!newButton.menuOpen"
    [ngClass]="isSidebarCollapsed ? 'small' : 'expanded'"
  >
    + <span class="sidebar__item-text">NEW &nbsp; &nbsp;</span>
  </button>
</div>

<mat-menu #newMenu="matMenu">
  <div class="dropdown__menu grid-y grid-padding-x">
    <button
      *ngIf="canImport"
      (click)="modal.open.next({ modalId: 'importFiles' })"
      class="dropdown__button cell flex-container align-middle margin-vertical-1"
    >
      <span class="dropdown__icon padding-right-1">
        <rav-icon name="file"></rav-icon>
      </span>
      Import Files
    </button>

    <div *ngIf="canImportFolder" class="cell flex-container align-middle margin-bottom-1">
      <rav-import-folder></rav-import-folder>
    </div>

    <mat-divider *ngIf="canImport && (canCreateFolders || canCreateTemplate)"></mat-divider>
    <button
      *ngIf="canCreateFolders"
      (click)="modal.open.next({ modalId: 'createFolders' })"
      class="dropdown__button cell flex-container align-middle margin-vertical-1"
    >
      <span class="dropdown__icon padding-right-1">
        <rav-icon name="new-folder"></rav-icon>
      </span>
      Create Folder
    </button>
    <button
      *ngIf="canCreateTemplate"
      (click)="router.navigateByUrl('/templates/new')"
      class="dropdown__button cell flex-container align-middle margin-bottom-1"
    >
      <span class="dropdown__icon padding-right-1">
        <rav-icon name="new-template"></rav-icon>
      </span>
      Create Template
    </button>
  </div>
</mat-menu>
